<template>
    <div>
        <div class="mb10">카테고리 추가</div>
        <div class="table_wrap">
            <div class="c_table_wrap table_search_wrap">
                <table>
                    <colgroup>
                        <col width="200px;">
                        <col width="">
                    </colgroup>
                    <tbody>
                    <tr>
                        <td class="c_t_title">카테고리 명</td>
                        <td>
                            <div class="search">
                                <el-input class="table_s_input"
                                          v-model="writeInput"
                                          size=""
                                          placeholder="카테고리명을 입력해주세요."
                                          @keypress.enter.native="addCategory(writeInput)"
                                />
                                <el-button type="primary" class="search_btn ml10" @click="addCategory(writeInput)">추가
                                </el-button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="mb10 pt30">
                카테고리 리스트
            </div>
            <el-table-draggable :change="checkMove()" handle=".handle">
                <el-table
                    :data="todayCategoryData"
                    style="width: 100%"
                    empty-text="데이터가 없습니다."
                >
                    <el-table-column
                        label="#"
                        width="70"
                        class-name="handle"
                    >
                        <template slot-scope="scope">
                            <div class="today_category_seq handle">
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column
                        align="center"
                        width=""
                        label="카테고리명"
                        class-name="table_bottons"
                    >
                        <template slot-scope="scope">
                            <div class="">
                                <el-input v-model="scope.row.bc_name"></el-input>
                            </div>
                        </template>
                    </el-table-column>


                    <el-table-column
                        align="center"
                        width="250"
                        label="노출설정"
                        class-name="table_bottons"
                    >
                        <template slot-scope="scope">
                            <div class="cursor">
                                <el-radio-group v-model="scope.row.bc_is_display">
                                    <el-radio :label="1">노출</el-radio>
                                    <el-radio :label="0">노출안함</el-radio>
                                </el-radio-group>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="200"
                        label="관리"
                        class-name="table_bottons"
                    >
                        <template slot-scope="scope">
                            <el-button
                                size="mini"
                                type="danger"
                                @click="deleteConfirm(scope.row)">삭제
                            </el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </el-table-draggable>
        </div>

        <div class="table_search search_btn_wrap text_center mt20">
            <el-button type="primary" class="search_btn" @click="updateCategory()">저장</el-button>
        </div>
        <today-category-delete-modal :categoryData="categoryData"
                                     :successFunc="getCategory"></today-category-delete-modal>
    </div>
</template>

<script>
import ElTableDraggable from 'element-ui-el-table-draggable';
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/mixins/event-bus";
import TodayCategoryDeleteModal from "@/components/modal/TodayCategoryDeleteModal";

export default {
    name: "TodayCategoryComponent",
    mixins: [alertMixins],
    components: {TodayCategoryDeleteModal, ElTableDraggable},
    inject: [],
    provide() {
        return {}
    },
    props: {
    },
    data() {
        return {
            writeInput: '',
            todayCategoryData: [],
            categoryData: {},
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.getCategory()
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        getCategory() {
            let params = {
                ip: 1
            }
            EventBus.$emit('changeLoading', true);

            try {
                this.$api.$today.getTodayCategory(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type !== 1) {
                        this.errorAlert('카테고리 리스트를 가져올수없습니다.');
                        EventBus.$emit('changeLoading', false);
                    }
                    this.todayCategoryData = res.List
                    EventBus.$emit('changeLoading', false);
                })
            } catch (e) {
                console.log(e);
                EventBus.$emit('changeLoading', false);
            }
        },

        addCategory(data) {
            let params = {
                bc_name: data
            }
            EventBus.$emit('changeLoading', true);
            try {
                this.$api.$today.writeTodayCategory(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type !== 1) {
                        this.errorAlert('카테고리 추가생성에 실패하였습니다.');
                        EventBus.$emit('changeLoading', false);
                        return false;
                    }
                    this.addAfterFunc();
                })
            } catch (e) {
                console.log(e)
                EventBus.$emit('changeLoading', false);
            }
        },

        addAfterFunc() {
            let content = '추가하였습니다.';
            this.createAlert({
                content: content,
                hide: () => {
                    EventBus.$emit('changeLoading', false)
                    this.getCategory();
                }
            })
        },

        checkMove() {
            util.Array.each(this.ApiData, (file, index, arr) => {
                this.ApiData[index].bc_seq = index + 1;
            })
        },

        deleteConfirm(row) {
            this.categoryData = row;
            this.$nextTick(() => {
                this.$modal.show('today-category-delete-modal');
            })
        },

        updateCategory(index = 0) {
            let category = this.todayCategoryData[index];
            console.log(`category: ${JSON.stringify(category)}`)
            let params = {
                bc_idx: category.bc_idx,
                bc_name: category.bc_name,
                bc_is_display: category.bc_is_display,
                bc_seq: index+1,
            };
            this.$api.$today.updateTodayCategory(params).then(res => res.Data.Result).then(res => {
                if (res.Info.Type !== 1) {
                    this.errorAlert(`${category.bc_name}의 저장에 실패하였습니다.`);
                    return false
                }
                if (index < this.todayCategoryData.length - 1) {
                    index = index + 1;
                    this.updateCategory(index);
                } else {
                    this.createAlert({
                        title: '',
                        content: '저장 되었습니다.',
                        btnText: '확인',
                        hide: () => {
                        }
                    })
                }

            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
